var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DatePicker',{attrs:{"type":_vm.formate || 'date',"clearable":_vm.clearable,"placeholder":"选择日期"},on:{"on-open-change":_vm.openChange,"on-clickoutside":_vm.clickoutside,"on-change":_vm.selectDate,"on-clear":_vm.clear},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32337020","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../common/src/components/lyyymmdd.vue
// module id = null
// module chunks = 